import React, { useRef, useState } from "react";
import { Button, Form, Input, message } from "antd";

import classes from "./ForgetPassword.module.css";
import { OtpForm } from "../Otp/Otp";
import { forgotPassVerifyOtp, forgotPassword } from "api/consumerLogin";
import AuthScreenContainer from "containers/AuthScreenContainer";
import { useNavigate } from "react-router-dom";
import { isValidEmail } from "utils/validation";
import { VALIDATION } from "constants/strings";
import { FormInstance } from "antd/lib";

export const ForgetPassword: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const [showOtp, setShowOtp] = useState(false);
  const [email, setEmail] = useState("");
  const navigate = useNavigate();
  const formRef = useRef<FormInstance | null>(null);

  const handleSubmit = async () => {
    const email = formRef.current?.getFieldValue("email");

    if (!email) {
      message.error("Please enter your email");
      return;
    }
    if (!isValidEmail(email)) {
      message.error("Please enter a valid email");
      return;
    }
    setLoading(true);
    const res = await forgotPassword(email);
    setLoading(false);

    if (res) {
      setEmail(email);
      setShowOtp(true);
    }
  };

  if (showOtp) {
    return (
      <OtpForm
        email={email}
        next={() =>
          navigate("/new-password", {
            state: {
              email
            }
          })
        }
        verify={forgotPassVerifyOtp}
      />
    );
  }

  return (
    <AuthScreenContainer
      heading="Forgot Password?"
      subHeading="Please enter your email address below, and we will send you an One-Time Password (OTP) to reset your password"
      footerLinkText="Back to login"
      footerLink="/login">
      <div className={classes.ForgetPassword}>
      <Form requiredMark={false} ref={formRef} onFinish={handleSubmit} className="Form" layout="vertical" style={{ width: "100%" }}>
          <Form.Item 
            name="email" 
            label="Email"
            rules={[
              {
                required: true,
                whitespace: true,
                message: VALIDATION.fieldIsRequired
              },
              {
                type: "email",
                message: VALIDATION.invalidEmail
              }
            ]}
          >
            <Input
              type="email"
            />
          </Form.Item>
          <Button
            loading={loading}
            disabled={loading}
            style={{
              width: "100%",
              height: "56px",
              fontSize: "20px",
              fontWeight: 600,
              lineHeight: "29px",
              textAlign: "center",
              borderRadius: "8px",
            }}
            // className={classes.ForgetPasswordButton}
            htmlType="submit">
            Receive OTP
          </Button>
        </Form>
      </div>
    </AuthScreenContainer>
  );
};
